import { useEffect } from "react";
import { useDispatch } from "react-redux";

export function useRouteData(actionTypes: string[]): void {
  const dispatch = useDispatch();

  useEffect(() => {
    actionTypes.forEach((type) => dispatch({ type }));
  }, [actionTypes, dispatch]);
}
